import React, { Component } from 'react';
//import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Menu } from 'semantic-ui-react';
//import { Link } from 'react-router-dom';
import './NavMenu.css';
//import './HeaderNav.scss';
import fpLogo from '../Images/logo.png';

export class NavMenu extends Component {
  static displayName = NavMenu.name;

  constructor (props) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

    render() {
        
        return (

            <Menu className="inverted tabular massive menuPadding" color="blue">

                <img src={fpLogo} alt="logo" />
                </Menu>
           

        );
    }
}
